import EventEmitter from '@/utils/events.ts'
import { TLiftMonitoringEvent } from '@/pages/Equipment/pages/LiftPage/pages/LiftMonitoring/liftMonitoring.eventEmitter.ts'

const liftChartEventEmitter = new EventEmitter<TLiftMonitoringEvent>()
export default liftChartEventEmitter
